  import React, { useState, useEffect, useMemo, useRef } from "react";
  import "./AudienceSegments.css";
  import { createTheme, ThemeProvider } from "@mui/material/styles";
  import { CssBaseline } from "@mui/material";
  import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    Autocomplete,
    TextField,
    Chip,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
  } from "@mui/material";
  import { Doughnut } from "react-chartjs-2";
  import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
  } from "chart.js";
  import { data } from "./mockData";
  import { publishersData } from "./publishersData";
  import Slider from "react-slick";
  import "slick-carousel/slick/slick.css";
  import "slick-carousel/slick/slick-theme.css";
  import RequestSegments from "../requestSegments/RequestSegments";
  import { END_POINTS } from "../../../../services/endpoint/endPoint";
  import ApiCallServices from "../../../../services/ApiCallServices";
  import CollapsibleSection from "../../../common/collapsible-sction/CollapsibleSection";
  import PdfExport from "./PdfExport";
  console.log(publishersData);

  ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
  );

  const theme = createTheme({
    typography: {
      fontFamily: "'Gilroy-Regular', sans-serif",
    },
  });
  function AudienceSegments() {
    const contentRef = useRef(null);
    const [publishersData, setPublishersData] = useState([]);
    const [geoOptions, setGeoOptions] = useState([]);
    const [loadingGeo, setLoadingGeo] = useState(true);
    const [reachData, setReachData] = useState([]);

    useEffect(() => {
      ApiCallServices.getlisting(END_POINTS.countryList + "?segmentStatus=1")
        .then((res) => {
          if (res.status === 200) {
            const countries = res.data.data.map((country) => ({
              value: country.ccode,
              label: country.name,
            }));
            setGeoOptions(countries);
          }
        })
        .catch((error) => {
          console.error(
            error?.response?.data?.error || "Error loading countries",
          );
        })
        .finally(() => setLoadingGeo(false));
    }, []);

    const [totalDisplayCPM, setTotalDisplayCPM] = useState(0);
    const [totalVideoCPM, setTotalVideoCPM] = useState(0);
    const [totalCTVCPM, setTotalCTVCPM] = useState(0);
    const [showHideModal, setShowHideModal] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleOpenModal = () => setShowHideModal(true);
    const handleCloseModal = () => setShowHideModal(false);

    const [selectedCountries, setSelectedCountries] = useState([]);
    const [selectedSegments, setSelectedSegments] = useState([]);
    const [subSegments, setSubSegments] = useState({});
    const [searchQuery, setSearchQuery] = useState("");

    const user = JSON.parse(localStorage.getItem("user"));

    

    //console.log("User ID =====super_admin===================================== :", user["role"]);
    






    const handleSubSegmentChange = (segment, newSubSegments) => {
      setSubSegments((prevState) => ({
        ...prevState,
        [segment]: newSubSegments,
      }));
    };

    const handleCountryChange = (event, newValue) => {
      const selectedValues = newValue.map((item) => item.value);
      setSelectedCountries(selectedValues);
      console.log("Selected country codes:", selectedValues);
      setSelectedSegments((prevSegments) =>
        prevSegments.filter((segment) =>
          data.some(
            (item) =>
              newValue?.includes(item.Geo) &&
              item["Audience Segments"] === segment,
          ),
        ),
      );

      setSubSegments((prevSubSegments) => {
        const updatedSubSegments = {};
        Object.keys(prevSubSegments).forEach((segment) => {
          if (
            data.some(
              (item) =>
                newValue.includes(item.Geo) &&
                item["Audience Segments"] === segment,
            )
          ) {
            updatedSubSegments[segment] = prevSubSegments[segment];
          }
        });
        return updatedSubSegments;
      });
    };

    const handleSegmentChange = (event, newValue) => {
      setSelectedSegments(newValue);
      setSubSegments((prevSubSegments) => {
        const updatedSubSegments = {};
        newValue.forEach((segment) => {
          if (prevSubSegments[segment]) {
            updatedSubSegments[segment] = prevSubSegments[segment];
          }
        });
        return updatedSubSegments;
      });
    };

    const filteredData = useMemo(() => {
      return reachData;
    }, [reachData]);

    const formatNumber = (num) => {
      if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
      if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
      if (num >= 1_000) return (num / 1_000).toFixed(1) + "K";
      return num.toLocaleString();
    };

    const totalReach = useMemo(() => {
      return filteredData.reduce((sum, item) => sum + (item["Reach"] || 0), 0);
    }, [filteredData]);

    const [segmentOptions, setSegmentOptions] = useState([]);
    const [allSegmentOptions, setAllSegmentOptions] = useState([]); // full list for ID resolution
    const [subSegmentMap, setSubSegmentMap] = useState({});

    const audienceSegments = useMemo(() => {
      return segmentOptions.map((s) => s.name);
    }, [segmentOptions]);

    const subSegmentsData = useMemo(() => {
      return subSegmentMap;
    }, [subSegmentMap]);

    useEffect(() => {
      if (!selectedCountries?.length) return;

      const fetchSegments = async () => {
        const payload = {
          geo_id: selectedCountries,
          parent_id: 0,
          status: 1,
        };
        try {
          const res = await ApiCallServices.create(
            END_POINTS.segmentssTableData,
            payload,
          );
          if (res.status === 200 && Array.isArray(res.data.data)) {
            console.log(res.data.data);
            setSegmentOptions(res.data.data);
          } else {
            setSegmentOptions([]);
          }
        } catch (error) {
          console.error("Error fetching segments:", error);
          setSegmentOptions([]);
        }
      };

      fetchSegments();
    }, [selectedCountries]);

    useEffect(() => {
      if (!selectedCountries?.length) return;

      const fetchSegments = async () => {
        const payload = {
          geo_id: selectedCountries,
          parent_id: 0,
          status: 1,
        };

        try {
          const res = await ApiCallServices.create(
            END_POINTS.segmentssTableData,
            payload,
          );
          if (res.status === 200 && Array.isArray(res.data.data)) {
            setSegmentOptions(res.data.data);
            setAllSegmentOptions(res.data.data);
          } else {
            setSegmentOptions([]);
            setAllSegmentOptions([]);
          }
        } catch (error) {
          console.error("Error fetching segments:", error);
          setSegmentOptions([]);
          setAllSegmentOptions([]);
        }
      };

      fetchSegments();
    }, [selectedCountries]);

    useEffect(() => {
      const fetchSubSegments = async () => {
        let map = {};
        let subSegmentList = [];

        for (const seg of segmentOptions) {
          if (!selectedSegments.includes(seg.name)) continue;

          const data = {
            geo_id: seg.geo_id,
            parent_id: seg.id,
            status: 1,
          };

          const res = await ApiCallServices.create(
            END_POINTS.segmentssTableData,
            data,
          );

          if (res.status === 200 && Array.isArray(res.data.data)) {
            const subs = res.data.data;
            map[seg.name] = subs.map((s) => s.name);
            subSegmentList.push(...subs);
          }
        }
        setSubSegmentMap(map);
        setAllSegmentOptions((prev) => {
          const existingIds = new Set(prev.map((s) => s.id));
          const newSubs = subSegmentList.filter((s) => !existingIds.has(s.id));
          return [...prev, ...newSubs];
        });
      };

      if (selectedSegments.length && segmentOptions.length) {
        fetchSubSegments();
      }
    }, [selectedSegments]);
    useEffect(() => {
      const payload = {
        name: searchQuery || "",
        geo: selectedCountries,
        segmentIds: segmentOptions
          .filter((s) => selectedSegments.includes(s.name))
          .map((s) => s.id),
        subsegmentIds: Object.entries(subSegments).flatMap(
          ([seg, selectedSubs]) =>
            selectedSegments.includes(seg)
              ? selectedSubs
                  .map(
                    (sub) =>
                      allSegmentOptions.find((opt) => opt.name === sub)?.id,
                  )
                  .filter(Boolean)
              : [],
        ),
        sortingcolumn: "avails",
        sortingorder: "DESC",
      };

      ApiCallServices.create(END_POINTS.topPublishersList, payload).then(
        (res) => {
          if (res.status === 200) setPublishersData(res.data.data);
          const agg = res.data.aggregate || {};
          setTotalDisplayCPM(
            agg.averageDisplayCPM ? +agg.averageDisplayCPM.toFixed(2) : 0,
          );
          setTotalVideoCPM(
            agg.averageVideoCPM ? +agg.averageVideoCPM.toFixed(2) : 0,
          );
          setTotalCTVCPM(agg.averageCTVCPM ? +agg.averageCTVCPM.toFixed(2) : 0);
        },
      );
    }, [
      searchQuery,
      selectedCountries,
      selectedSegments,
      subSegments,
      subSegmentMap,
    ]);

    useEffect(() => {
      const payload = {
        name: "", // optional search
        geo: selectedCountries,
        segmentIds: segmentOptions
          .filter((s) => selectedSegments.includes(s.name))
          .map((s) => s.id),
        subsegmentIds: Object.entries(subSegments).flatMap(
          ([seg, selectedSubs]) =>
            selectedSegments.includes(seg)
              ? selectedSubs
                  .map(
                    (sub) =>
                      allSegmentOptions.find((opt) => opt.name === sub)?.id,
                  )
                  .filter(Boolean)
              : [],
        ),
        sortingcolumn: "reach",
        sortingorder: "DESC",
      };

      ApiCallServices.create(END_POINTS.reachTableData, payload).then((res) => {
        if (res.status === 200 && res.data?.data) {
          const transformed = res.data.data.map((item, index) => ({
            Reach: item.reach || 0,
            Desktop: item.desktop || 0,
            Mobile: item.mobile || 0,
            SmartTV: item.smartTV || 0,
            Banner: item.banner || 0,
            Video: item.video || 0,
            Metro: item.metro || 0,
            "Non Metro": item.non_metro || 0,
            Male: item.male || 0,
            Female: item.female || 0,
          }));
          setReachData(transformed);
        }
      });
    }, [selectedCountries, selectedSegments, subSegments]);

    // Code added to max limit
    const allowedMaxReach = useMemo(() => {
      if (!selectedCountries.length) return null; // No cap if no country selected
      return selectedCountries.reduce((sum, code) => {
        return sum + (maxReachByCountry[code] || 0);
      }, 0);
    }, [selectedCountries]);

    // Final capped reach logic
    const cappedTotalReach = useMemo(() => {
      if (!allowedMaxReach) return totalReach; // No cap
      return Math.min(totalReach, allowedMaxReach);
    }, [totalReach, allowedMaxReach]);
    return (
      <ThemeProvider theme={theme}>

          <CssBaseline />
      <Card ref={contentRef}>

          { (user?.["role"] == "super_admin") &&
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
              <PdfExport contentRef={contentRef} filename="audience-segments" />
            </Box>
          }
          
          

          <div className="pdf-include">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <CollapsibleSection title="Audience Segments">
                <br/>
                  <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                      <CardInfo
                        title="Curated Reach"
                        value={formatNumber(cappedTotalReach)}
                        change="40%"
                        positive
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <CardInfo title="GEO Count" value="20+" change="10%" />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <CardInfo
                        title="Segments"
                        value="50+"
                        change="20%"
                        positive
                      />
                    </Grid>
                  </Grid>
                </CollapsibleSection>
              </Grid>
            </Grid>
          </Box>
          </div>
      
          
          <Box sx={{ flexGrow: 1 }} > 
            <Grid container spacing={4} >
              <Grid item xs={12}>
                <CollapsibleSection title="Supply Partners">
                  <Box sx={{ overflow: "visible", mt: 1 }}>
                    {" "}
                    {/* Reduced top margin */}
                    <Slider {...settings}>
                      {supplyPartnerLogos.map((logo, index) => (
                        <Box key={index} sx={{ px: 0.5, py: 1 }}>
                          {" "}
                          <Card
                            sx={{
                              width: "100%",
                              height: 120, // Reduced height
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              p: 2, // Reduced padding
                              boxShadow: 1,
                            }}
                          >
                            <img
                              src={logo}
                              alt={`Supply Partner ${index + 1}`}
                              style={{
                                width: "75%", // Adjusted width
                                height: "75%", // Adjusted height
                                objectFit: "contain",
                              }}
                            />
                          </Card>
                        </Box>
                      ))}
                    </Slider>
                  </Box>
                </CollapsibleSection>
              </Grid>


              </Grid>
          </Box>

          <div className="pdf-include">
          <Box sx={{ flexGrow: 1 }} > 
            <Grid container spacing={4} >

              <Grid item xs={12}>
                <CollapsibleSection title="Segments">
                  <CardContent>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={3}>
                        <TextField
                          fullWidth
                          value="Geo"
                          variant="outlined"
                          disabled
                          sx={{
                            "& .MuiInputBase-root": {
                              backgroundColor: "#f0f0f0",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <Autocomplete
                          multiple
                          options={geoOptions}
                          value={geoOptions.filter((opt) =>
                            selectedCountries.includes(opt.value),
                          )}
                          onChange={(event, newValue) =>
                            handleCountryChange(event, newValue)
                          }
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                key={index}
                                label={option.label} // use label here
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search Countries"
                              variant="outlined"
                              disabled={loadingGeo}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <TextField
                          fullWidth
                          value="Audience Segments"
                          variant="outlined"
                          disabled
                          sx={{
                            "& .MuiInputBase-root": {
                              backgroundColor: "#f0f0f0",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <Autocomplete
                          multiple
                          options={
                            Array.isArray(audienceSegments)
                              ? audienceSegments
                              : []
                          }
                          // getOptionDisabled={(option) =>
                          //     !data.some(item => selectedCountries.includes(item.Geo) && item["Audience Segments"] === option)
                          // }
                          disabled={!selectedCountries?.length}
                          // options={Array.isArray(audienceSegments) ? audienceSegments : []}
                          value={selectedSegments}
                          onChange={(event, newValue) =>
                            handleSegmentChange(event, newValue)
                          }
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                key={index}
                                label={option}
                                {...getTagProps({ index })}
                              />
                              // <Chip key={index} label={option} {...getTagProps({ index })} />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search Audience Segments"
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                    {selectedSegments?.length ? (
                      <Box
                        sx={{
                          mt: 3,
                          p: 2,
                          borderRadius: "8px",
                          backgroundColor: "#f9f9f9",
                        }}
                      >
                        <Typography variant="h6" sx={{ mb: 1, color: "#0049AA" }}>
                          Subsegments
                        </Typography>
                        {selectedSegments?.length === 0 ? (
                          <Typography color="textSecondary">
                            Select an audience segment to view subsegments.
                          </Typography>
                        ) : (
                          <Grid container spacing={2}>
                            {selectedSegments?.map((segment) => (
                              <Grid item xs={12} key={segment}>
                                <Grid container spacing={2} alignItems="center">
                                  <Grid item sx={{ width: 200 }}>
                                    <Chip
                                      label={segment}
                                      sx={{ fontWeight: "bold" }}
                                    />
                                  </Grid>
                                  <Grid item xs>
                                    <Autocomplete
                                      multiple
                                      options={subSegmentsData[segment] || []}
                                      value={subSegments[segment] || []}
                                      onChange={(event, newValue) =>
                                        handleSubSegmentChange(segment, newValue)
                                      }
                                      renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                          <Chip
                                            key={index}
                                            label={option}
                                            {...getTagProps({ index })}
                                          />
                                        ))
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder={`Select subsegments for ${segment}`}
                                          variant="outlined"
                                        />
                                      )}
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            ))}
                          </Grid>
                        )}
                      </Box>
                    ) : (
                      <></>
                    )}
                  </CardContent>
                </CollapsibleSection>
              </Grid>


              </Grid>
          </Box>
          </div>

          <div className="pdf-include">
          <Box sx={{ flexGrow: 1 }} > 
            <Grid container spacing={4} >

              <Grid item xs={12}>
                <CollapsibleSection title="Distributions">
                  <Grid container spacing={2}>
                    {selectedCountries?.includes("India") ? (
                      <Grid
                        item
                        xs={12}
                        sm={selectedCountries?.includes("India") ? 3 : 4}
                      >
                        {" "}
                        <CitiesPieChart filteredData={filteredData} />{" "}
                      </Grid>
                    ) : (
                      ""
                    )}
                    <Grid
                      item
                      xs={12}
                      sm={selectedCountries?.includes("India") ? 3 : 4}
                    >
                      <DevicePieChart filteredData={filteredData} />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={selectedCountries?.includes("India") ? 3 : 4}
                    >
                      <GenderPieChart filteredData={filteredData} />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={selectedCountries?.includes("India") ? 3 : 4}
                    >
                      <FormatPieChart filteredData={filteredData} />
                    </Grid>
                  </Grid>
                </CollapsibleSection>
              </Grid>
            </Grid>
          </Box>
        </div>

        <div className="pdf-include pdf-break">
          <Box sx={{ flexGrow: 2 }} > 
            <Grid container spacing={4} >
              <Grid item xs={12}>
                <CollapsibleSection title="Publishers">
                  <CardContent>
                    <TextField
                      fullWidth
                      placeholder="Search"
                      variant="outlined"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      sx={{ mb: 2 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">🔍</InputAdornment>
                        ),
                      }}
                    />

                    {/* Table of Publishers */}

                    {!publishersData?.length ? (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "40px 0",
                          minWidth: "100%",
                          fontSize: "16px",
                          color: "#666",
                        }}
                      >
                        No Publishers Available For Selected Filters
                      </div>
                    ) : (
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>
                                <Typography variant="body1" fontWeight="bold">
                                  Publishers
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body1" fontWeight="bold">
                                  Domain
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body1" fontWeight="bold">
                                  Avails
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {publishersData.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell>
                                  <Typography variant="body1">
                                    {row?.Publisher}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <a
                                    href={
                                      typeof row.URL === "string" &&
                                      row.URL.trim() !== ""
                                        ? row.URL.startsWith("http")
                                          ? row.URL
                                          : `https://${row.URL}`
                                        : "#"
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#007bff",
                                      textDecoration: "none",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <Typography variant="body1" component="span">
                                      {row.URL || "N/A"}
                                    </Typography>
                                  </a>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body1">
                                    {formatNumber(row?.Avails)}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </CardContent>
                </CollapsibleSection>
              </Grid>
            </Grid>
          </Box>
        </div>

        <div className="pdf-include">
          <Box sx={{ flexGrow: 3 }} > 
            <Grid container spacing={4} >
              <Grid item xs={12} sm={3}>
                <CardInfo
                  title="Display CPM"
                  value={`${getCurrencySignByCountry(
                    selectedCountries,
                  )}${totalDisplayCPM}`}
                  change="40%"
                  positive
                />
              </Grid>
            
              <Grid item xs={12} sm={3}>
                <CardInfo
                  title="Video CPM"
                  value={`${getCurrencySignByCountry(
                    selectedCountries,
                  )}${totalVideoCPM}`}
                  change="10%"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <CardInfo
                  title="CTV CPM"
                  value={`${getCurrencySignByCountry(
                    selectedCountries,
                  )}${totalCTVCPM}`}
                  change="20%"
                  positive
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleOpenModal}
                  sx={{
                    height: "100%",
                    padding: 2,
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                    borderRadius: 2,
                    boxShadow: 3,
                    textTransform: "none",
                  }}
                >
                  Request Deal
                </Button>
              </Grid>
            </Grid>

            {/* Dialog for Request Form */}
            <div className={`modal form-modal ${showHideModal ? "show" : ""}`}>
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">Request Deal</h4>
                    <i
                      className="fa-regular fa-circle-xmark close-icon"
                      onClick={() => {
                        handleCloseModal();
                        setIsSubmitted(false);
                      }}
                    ></i>
                  </div>
                  <div className="modal-body">
                    {showHideModal ? (
                      <RequestSegments
                        handleCloseModal={handleCloseModal}
                        isSubmitted={isSubmitted}
                        setIsSubmitted={setIsSubmitted}
                      />
                    ) : (
                      ""
                    )}{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className={`${showHideModal ? "overlay" : ""}`}></div>
          </Box>
        </div>

        </Card>

      </ThemeProvider>
    );
  }

  const CardInfo = ({ title, value, change, positive }) => {
    return (
      <Card
        sx={{
          borderRadius: "12px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          pt: 2,
          pb: 0,
          minHeight: "100px",
          minWidth: "160px",
        }}
      >
        <CardContent sx={{ textAlign: "center", p: 1 }}>
          <Typography variant="h5" sx={{ mb: 1 }}>
            {title}
          </Typography>

          <Typography
            variant="h3"
            sx={{ fontWeight: "bold", color: positive ? "#004988" : "#28a9e2" }}
          >
            {value}
          </Typography>
        </CardContent>
      </Card>
    );
  };

  const CitiesPieChart = ({ filteredData }) => {
    const totalMetroReach = filteredData.reduce(
      (sum, item) => sum + item.Metro,
      0,
    );
    const totalNonMetroReach = filteredData.reduce(
      (sum, item) => sum + item["Non Metro"],
      0,
    );

    const doughnutData = {
      labels: ["Metro", "Non-Metro"],
      datasets: [
        {
          data: [totalMetroReach, totalNonMetroReach],
          backgroundColor: ["#FF6384", "#36A2EB"],
          borderWidth: 1,
        },
      ],
    };

    return (
      <Card sx={{ borderRadius: "12px", p: 2 }}>
        <CardContent>
          <Typography
            variant="h6"
            sx={{ mb: 2, color: "#0049AA", textAlign: "left" }}
          >
            Metro vs Non-Metro
          </Typography>
          <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid item xs={12} sm={6}>
              <Box display="flex" justifyContent="center">
                <Doughnut
                  data={doughnutData}
                  options={{
                    cutout: "50%",
                    plugins: { legend: { display: false } },
                  }}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              display="flex"
              flexDirection="column"
              sx={{ alignItems: { xs: "center", sm: "flex-start" } }}
            >
              {["Metro", "Non-Metro"].map((label, index) => (
                <Box key={index} display="flex" alignItems="center" mb={1}>
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      bgcolor: doughnutData.datasets[0].backgroundColor[index],
                      borderRadius: "50%",
                      mr: 1,
                    }}
                  />
                  <Typography variant="body2">{label}</Typography>
                </Box>
              ))}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  };

  const GenderPieChart = ({ filteredData }) => {
    const totalMaleReach = filteredData.reduce((sum, item) => sum + item.Male, 0);
    const totalFemaleReach = filteredData.reduce(
      (sum, item) => sum + item.Female,
      0,
    );

    const doughnutData = {
      labels: ["Male", "Female"],
      datasets: [
        {
          data: [totalMaleReach, totalFemaleReach],
          backgroundColor: ["#3498db", "#e74c3c"],
          borderWidth: 1,
        },
      ],
    };

    return (
      <Card sx={{ borderRadius: "12px", p: 2 }}>
        <CardContent>
          <Typography
            variant="h6"
            sx={{ mb: 2, textAlign: "left", color: "#0049AA" }}
          >
            Gender Distribution
          </Typography>
          <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid item xs={12} sm={6}>
              <Box display="flex" justifyContent="center">
                <Doughnut
                  data={doughnutData}
                  options={{
                    cutout: "50%",
                    plugins: { legend: { display: false } },
                  }}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              display="flex"
              flexDirection="column"
              sx={{ alignItems: { xs: "center", sm: "flex-start" } }}
            >
              {["Male", "Female"].map((label, index) => (
                <Box key={index} display="flex" alignItems="center" mb={1}>
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      bgcolor: doughnutData.datasets[0].backgroundColor[index],
                      borderRadius: "50%",
                      mr: 1,
                    }}
                  />
                  <Typography variant="body2">{label}</Typography>
                </Box>
              ))}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  };

  const FormatPieChart = ({ filteredData }) => {
    const totalBannerReach = filteredData.reduce(
      (sum, item) => sum + item.Banner,
      0,
    );
    const totalVideoReach = filteredData.reduce(
      (sum, item) => sum + item.Video,
      0,
    );

    const doughnutData = {
      labels: ["Banner", "Video"],
      datasets: [
        {
          data: [totalBannerReach, totalVideoReach],
          backgroundColor: ["#4BC0C0", "#9966FF"],
          borderWidth: 1,
        },
      ],
    };

    return (
      <Card sx={{ borderRadius: "12px", p: 2 }}>
        <CardContent>
          <Typography
            variant="h6"
            sx={{ mb: 2, color: "#0049AA", textAlign: "left" }}
          >
            Format Distribution
          </Typography>
          <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid item xs={12} sm={6}>
              <Box display="flex" justifyContent="center">
                <Doughnut
                  data={doughnutData}
                  options={{
                    cutout: "50%",
                    plugins: { legend: { display: false } },
                  }}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              display="flex"
              flexDirection="column"
              sx={{ alignItems: { xs: "center", sm: "flex-start" } }}
            >
              {["Banner", "Video"].map((label, index) => (
                <Box key={index} display="flex" alignItems="center" mb={1}>
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      bgcolor: doughnutData.datasets[0].backgroundColor[index],
                      borderRadius: "50%",
                      mr: 1,
                    }}
                  />
                  <Typography variant="body2">{label}</Typography>
                </Box>
              ))}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  };

  const DevicePieChart = ({ filteredData }) => {
    const totalDesktopReach = filteredData.reduce(
      (sum, item) => sum + item.Desktop,
      0,
    );
    const totalMobileReach = filteredData.reduce(
      (sum, item) => sum + item.Mobile,
      0,
    );
    const totalSmartTVReach = filteredData.reduce(
      (sum, item) => sum + item.SmartTV,
      0,
    );

    const doughnutData = {
      labels: ["Desktop", "Mobile", "Smart TV"],
      datasets: [
        {
          data: [totalDesktopReach, totalMobileReach, totalSmartTVReach],
          backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
          borderWidth: 1,
        },
      ],
    };

    return (
      <Card sx={{ borderRadius: "12px", p: 2 }}>
        <CardContent>
          <Typography
            variant="h6"
            sx={{ mb: 2, color: "#0049AA", textAlign: "left" }}
          >
            Device Distribution
          </Typography>
          <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid item xs={12} sm={6}>
              <Box display="flex" justifyContent="center">
                <Doughnut
                  data={doughnutData}
                  options={{
                    cutout: "50%",
                    plugins: { legend: { display: false } },
                  }}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              display="flex"
              flexDirection="column"
              sx={{ alignItems: { xs: "center", sm: "flex-start" } }}
            >
              {["Desktop", "Mobile", "Smart TV"].map((label, index) => (
                <Box key={index} display="flex" alignItems="center" mb={1}>
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      bgcolor: doughnutData.datasets[0].backgroundColor[index],
                      borderRadius: "50%",
                      mr: 1,
                    }}
                  />
                  <Typography variant="body2">{label}</Typography>
                </Box>
              ))}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  };

  const supplyPartnerLogos = [
    "https://bi-api.tecreo.io/uploads/Equativ.png",
    "https://bi-api.tecreo.io/uploads/Smaato.svg",
    "https://bi-api.tecreo.io/uploads/Loopme.svg",
    "https://bi-api.tecreo.io/uploads/Index_Exchange.png",
    "https://bi-api.tecreo.io/uploads/OpenX.png",
    "https://bi-api.tecreo.io/uploads/Criteo.png",
    "https://bi-api.tecreo.io/uploads/Pubmatic.png",
    "https://bi-api.tecreo.io/uploads/Magnite.webp",
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  function getCurrencySignByCountry(country) {
    const countryCurrencyMap = {
      US: "$ ",
      Canada: "$ ",
      India: "$ ",
      Indonesia: "$ ",
      GCC: "$ ",
    };

    return countryCurrencyMap[country] || "$ ";
  }

  const maxReachByCountry = {
    AU: 13600000,
    BR: 10600000,
    CA: 20650000,
    CN: 70450000,
    DE: 41750000,
    EG: 58250000,
    FR: 34250000,
    GB: 34600000,
    GCC: 30600000,
    ID: 141750000,
    IN: 725450000,
    IT: 2950000,
    JP: 6250000,
    KR: 25900000,
    NZ: 26700000,
    SG: 30200000,
    TH: 35850000,
    US: 170050000,
    VN: 50050000,
    MY: 17800000,
  };

  export default AudienceSegments;
